// extracted by mini-css-extract-plugin
export default {"box":"HorizontalTabs_box__xbmXg"};